<template>
  <div class="page-container">
    <Filter ref="filterRef" :params="params" @search="searchData">
      <template #handle>
        <el-form-item>
          <el-button v-show="authList.includes('cloneConfig:upload')" type="primary" @click="addConfigTable(0)">{{$t('process.configtable.localUpload')}}</el-button>
          <el-button v-show="authList.includes('cloneConfig:remoteClone')" type="primary" @click="addConfigTable(1)">{{$t('process.configtable.remoteClone')}}</el-button>
        </el-form-item>
      </template>
    </Filter>
    <Table :tableData="tableDataList" :total="total" @update="updatePage">
      <el-table-column prop="name" :label="$t('process.cloningrecord.processConfiguration')" />
      <el-table-column prop="source" :label="$t('process.configtable.fileSource')" >
        <template #default="scope">
          <span>{{scope.row.source ? $t("process.configtable.remote"):$t("process.configtable.local")}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="robotSn" :label="$t('process.cloningrecord.sourceRobotCode')" />
      <el-table-column prop="cabinetSn" :label="$t('process.configtable.sourceControlCabinetCode')" />
      <el-table-column prop="cabinetSn" :label="$t('process.configtable.sourceControlCabinetCode')">
        <template #default="scope">
          <span v-if="scope.row.cabinetSn?.length > 4  && ![undifined, 'undifined', 'Invalid-ID'].includes(scope.row.cabinetSn)">{{scope.row.cabinetSn}}</span>
          <el-popover
            v-else
            placement="top-start"
            :width="400"
            trigger="hover"
            title=""
          >
            <template #default>
              <el-descriptions title="" column="1" border>
                <el-descriptions-item :label="$t('error.alarm.reportinformation')">{{scope.row.cabinetSN}}</el-descriptions-item>
                <el-descriptions-item :label="$t('error.alarm.solution')">{{$t('error.alarm.solutionInfo')}}</el-descriptions-item>
                <el-descriptions-item :label="$t('error.alarm.method1')">{{$t('error.alarm.methodInfo1')}}</el-descriptions-item>
                <el-descriptions-item :label="$t('error.alarm.method2')">{{$t('error.alarm.methodInfo2')}}</el-descriptions-item>
              </el-descriptions>
            </template>
            <template #reference>
              <span style="cursor: pointer;">
                {{ $t('error.alarm.pendingReport') }}
                <i class="el-icon-warning" style="margin-left: 6px;color: #E6A23C;"></i>
              </span>
            </template>
          </el-popover>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="configList" :label="$t('collect.messagelist.fileName')" /> -->
      <el-table-column prop="configList" :label="$t('collect.messagelist.fileName')" >
        <template #default="scope">
          <span>
            {{
              scope.row.configList.split(",").map(item=> {
                const foundItem = configTypeLists.find(type => type.value === item);
                return foundItem ? foundItem.label : item; // 如果未找到，保留原值
              }).join(",")
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="fileSize" :label="$t('process.cloningrecord.fileSize')" >
        <template #default="scope">
          <span>
            {{
              scope.row.source == 1 ? getSum(scope.row) : scope.row.fileSize
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('process.configtable.uploadStatus')" >
        <template #default="scope">
          <span>{{uploadStatus[scope.row.uploadStatus]}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="isDisable" :label="$t('status.largescreenm.isDisabled')" >
        <template #default="scope">
          <el-switch
            @change="enableChange(scope.row)"
            v-model="scope.row.isDisable"
            active-text=""
            inactive-text="">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="createBy" :label="$t('activity.list.creator')" />
      <el-table-column prop="createTime" :label="$t('collect.messagelist.uploadTime')" />
      <el-table-column prop="robotSn" :label="$t('activity.list.operation')" >
        <template #default="{ row }">
          <el-button
            v-show="authList.includes('cloneConfig:edit')"
            v-if="!row.hasCloneRecord && row.isDisable"
            @click="handleOperate(row,0)"
            type="text"
            size="small"
            >{{$t('activity.list.edit')}}</el-button
          >
          <el-button
            v-show="authList.includes('cloneConfig:clone')"
            v-if="row.isDisable && row.uploadStatus == 3"
            @click="handleOperate(row,1)"
            type="text"
            size="small"
            >{{$t('process.configtable.clone')}}</el-button
          >
          <el-button
            v-if="row.hasCloneRecord"
            @click="handleOperate(row,2)"
            type="text"
            size="small"
            >{{$t('process.configtable.cloneRecords')}}</el-button
          >
          <el-button
            v-if="!row.hasCloneRecord && !row.isDisable"
            @click="handleOperate(row,3)"
            type="text"
            size="small"
            >{{$t('activity.packetjoin.delete')}}</el-button
          >
        </template>
      </el-table-column>
    </Table>
  </div>
  <el-dialog
    :title="detailform.source?$t('process.configtable.remoteProcessConfigLibrary'): $t('process.configtable.localProcessConfigLibrary')"
    v-model="dialogFormVisible"
    destroy-on-close
    :modal="true"
    :append-to-body="true"
  >
      <el-form
        ref="detailformRef"
        class="dialog-form"
        :model="detailform"
        :rules="detailformRules"
        :label-width="curLang == 'zh-CN' ? '100px' : '170px'"
      >
        <el-form-item :label="$t('process.cloningrecord.processConfiguration')" prop="name">
          <el-input
            v-model="detailform.name"
            :placeholder="$t('process.cloningrecord.processConfiguration')"
            clearable
          />
        </el-form-item>
        <div class="desc_title">{{$t('process.configtable.sourceRobot')}}</div>
        <el-table
          :data="tableData1"
          tooltip-effect="dark"
          row-key="id"
        >
          <el-table-column :label="$t('activity.packetjoin.robotCode')" align="center">
            <template #default="scope">
              <div class="form">
                <el-form-item prop="robotSn" label-width="'0px'">
                  <el-select v-model="detailform.robotSn" :placeholder="$t('activity.packetjoin.robotCode')" :remote-method="robotSnQuery" @change="(val)=>onRobotChange(val)" filterable remote clearable>
                    <el-option
                      v-for="(item) in robotSnList"
                      :key="item.robotId"
                      :label="item.robotId"
                      :value="item.robotId"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="cabinetSn" :label="$t('collect.healthscorelist.ctrlCabCode')" align="center">
            {{ detailform.cabinetSn }}
          </el-table-column>
          <el-table-column prop="robotStatus" :label="$t('points.exchange.status')" align="center">
            {{ statusList[detailform.robotStatus] }}
          </el-table-column>
        </el-table>
        <div v-if="!detailform.source" class="desc_title" style="margin-top: 20px;">{{$t('process.configtable.uploadProcessConfig')}}</div>
        <el-form-item v-if="!detailform.source" label-width="0px" label="" prop="file">
          <el-table
            ref="multipleTable"
            :data="configList"
            tooltip-effect="dark"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column :width="curLang == 'zh-CN' ? '80px' : '120px'" :label="$t('activity.list.serialNo')">
              <template #default="scope">{{scope.$index + 1}}</template>
            </el-table-column>
            <el-table-column
              prop="name"
              :label="$t('process.configtable.configFile')"
              >
            </el-table-column>
            <el-table-column
              prop="file"
              :label="$t('process.configtable.configFile')"
              >
              <template #default="scope">
                <el-form-item label="" prop="file">      
                <Upload
                  :file-list="fileList"
                  :limit="1"
                  :auto-upload="false"
                  :on-change="(val)=>onFileChange(val,scope)"
                  :on-remove="(val)=>onFileRemove(val,scope.row)"
                >
                  <el-button :disabled="!!scope.row.file" type="text">{{$t('resource.list.clickToUploadFile')}}</el-button>
                  <template #tip>
                    <div v-if="!scope.row.file" class="el-upload__tip">{{$t('process.configtable.fileName')}}{{ scope.row.fileName }}</div>
                  </template>
                </Upload>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
         
        </el-form-item>
        <div v-if="detailform.source" class="desc_title" style="margin-top: 20px;">{{$t('process.configtable.selectProcessConfig')}}</div>
        <el-form-item v-if="detailform.source" label="" prop="configList" label-width="'0px'">
          <el-checkbox-group v-model="detailform.configList">
            <el-checkbox :label="$t('service.version.controller')"></el-checkbox>
            <el-checkbox :label="$t('process.cloningrecord.ioName')"></el-checkbox>
            <el-checkbox :label="$t('process.cloningrecord.extendedIO')"></el-checkbox>
            <el-checkbox :label="$t('process.cloningrecord.systemVariables')"></el-checkbox>
            <el-checkbox :label="$t('process.cloningrecord.safetyZone')"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button size="small" type="primary" @click="editSubmit"
          >{{$t('activity.list.confirm')}}</el-button
        >
      </template>
  </el-dialog>
</template>

<script>
import { request } from '@/utils/request'
import { common } from '../../common/mixin'
import Table from '@/components/table/index'
import Filter from '@/components/table/filter'
import dayjs from 'dayjs'
import { ElMessage, ElMessageBox } from "element-plus";
import Upload from '@/components/upload'
import { reqCloneConfig } from "@/api/robot"
import { robotStatusMap } from "@/common/constant";
import { computed } from "vue";
import { useStore } from "vuex"
// import { useI18n } from 'vue-i18n'
// const { t } = useI18n()
export default {
  components: {
    Table,
    Filter,
    Upload
  },
  mixins: [common],
  data () {
    const store = useStore()
    const uploadStatus = [
      {
        label: this.$t('process.cloningrecord.notStarted'),
        value: '0'
      },
      {
        label: this.$t('error.errorlog.waitingForRobotResponse'),
        value: '1'
      },
      {
        label: this.$t('process.configtable.uploading'),
        value: '2'
      },
      {
        label: this.$t('process.configtable.uploadCompleted'),
        value: '3'
      },
      {
        label: this.$t('collect.tasklist.uploadFailed'),
        value: '4'
      }
    ]
    const configTypeList = [
      {
        label: this.$t('service.version.controller'),
        value: '控制器',
        fileSize: 4.8
      },
      {
        label: this.$t('process.cloningrecord.ioName'),
        value: 'I/O名称',
        fileSize: 0.7
      },
      {
        label: this.$t('process.cloningrecord.extendedIO'),
        value: '扩展I/O',
        fileSize: 0.6
      },
      {
        label: this.$t('process.cloningrecord.systemVariables'),
        value: '系统变量',
        fileSize: 0.3
      },
      {
        label: this.$t('process.cloningrecord.safetyZone'),
        value: '安全区域',
        fileSize: 0.6
      }
    ]
    return {
      params: [
        {
          key: 'name',
          value: '',
          label: this.$t('process.cloningrecord.processConfiguration')
        },
        {
          key: 'robotSn',
          value: '',
          label: this.$t('service.upgrade.robotId')
        },
        {
          key: 'cabinetSn',
          value: '',
          label: this.$t('service.upgrade.controlCabinetId')
        },
        {
          type: 'Select',
          key: 'configTypeList',
          value: null,
          label: this.$t('process.configtable.configFile'),
          options: {
            data: configTypeList,
            label: 'label',
            value: 'value'
          },
          attrs: {
            multiple: true
          }
        },
        {
          type: 'Select',
          key: 'uploadStatus',
          value: null,
          label: this.$t('process.configtable.uploadStatus'),
          options: {
            data: uploadStatus,
            label: 'label',
            value: 'value'
          }
        },
        {
          type: 'Date',
          key: 'dateRange',
          value: [
            dayjs().subtract(6, 'month').format('YYYY-MM-DD') + ' 00:00:00',
            dayjs().format('YYYY-MM-DD') + ' 23:59:59'
          ],
          label: this.$t('process.configtable.uploadDate'),
          options: {
            type: 'datetimerange',
            format: 'YYYY-MM-DD HH:mm:ss',
            'value-format': 'YYYY-MM-DD HH:mm:ss',
            'range-separator': this.$t('activity.detail.to'),
            'start-placeholder': this.$t('activity.list.startDate'),
            'end-placeholder': this.$t('activity.list.endDate'),
            'default-time': [
              new Date(2000, 1, 1, 0, 0, 0),
              new Date(2000, 1, 1, 23, 59, 59)
            ]
          }
        }
      ],
      query: {},
      page: 1,
      size: 10,
      total: 0,
      tableDataList: [],
      dialogFormVisible: false,
      detailform: {
        name: '',
        robotSn: '',
        cabinetSn: '',
        file: '',
        configList: [],
        configList1: [],
        source: 0,
        taskType: 1,
      },
      configList: [
        {
          name: this.$t('service.version.controller'),
          file: null,
          type: 'ini',
          fileName: 'usersettings.ini',
          fileSize: 4.8
        },
        {
          name: this.$t('process.cloningrecord.ioName'),
          file: null,
          type: 'ini',
          fileName: 'aliasname.ini',
          fileSize: 0.7
        }, 
        {
          name: this.$t('process.cloningrecord.extendedIO'),
          file: null,
          type: 'xml',
          fileName: 'extiosetup.xml',
          fileSize: 0.6
        },
        {
          name: this.$t('process.cloningrecord.systemVariables'),
          file: null,
          type: 'var',
          fileName: 'jaka_user.var',
          fileSize: 0.3
        }, 
        {
          name: this.$t('process.cloningrecord.safetyZone'),
          file: null,
          type: 'xml',
          fileName: 'safezone.xml',
          fileSize: 0.6
        }
      ],
      tableData1: [{programName: 'fdasf'},],
      detailformRules:{
        name: {
          required: true,
          message: this.$t('process.configtable.enterProcessConfig'),
          trigger: 'change'
        },
        robotSn: {
          required: true,
          message: this.$t('process.configtable.selectRobotNumber'),
          trigger: 'change'
        },
        selectedRow: {
          required: true,
          message: this.$t('process.configtable.selectProcessProgram'),
          trigger: 'change'
        },
        configList: {
          required: true,
          message: this.$t('process.configtable.pSelectProcessConfig'),
          trigger: 'change'
        },
      },
      fileList: [],
      uploadStatus: {0:this.$t('process.cloningrecord.notStarted'),1:this.$t('error.errorlog.waitingForRobotResponse'),2:this.$t('process.configtable.uploading'),3:this.$t('process.configtable.uploadCompleted'),4:this.$t('collect.tasklist.uploadFailed')},
      selectedRow: null,
      robotSnList: [],
      statusList: robotStatusMap,
      curLang: computed(() => store.state.lang),
      configTypeLists: configTypeList,
      authList: JSON.parse(window.localStorage.getItem('authList'))
    }
  },
  created () {},
  mounted () {
    this.$refs.filterRef?.searchData()
  },
  methods: {
    getData () {
      request('getCloneConfig', {
        ...this.query,
        page: this.page,
        size: this.size,
        startTime: this.query.dateRange?.[0],
        endTime: this.query.dateRange?.[1]
      })
        .then(data => {
          this.tableDataList = data.records
          this.total = parseInt(data.total)
        })
        .catch(error => {
          console.error(error)
        })
    },
    getDataMap () {
      try {
        request('getArea', {
          parentId: 1
        }).then(data => {
          this.provinceList = data
        })
        request('getRobotStatusMap').then(data => {
          this.robotStatusList = data
        })
        request('getIndustryList').then(data => {
          this.industryList = data
        })
      } catch (error) {
        console.log(error)
      }
    },
    searchData (data) {
      this.query = data
      this.getData()
    },
    updatePage (page, size) {
      this.page = page || 1
      this.size = size || 10
      this.getData()
    },
    handleClick (row) {
      this.$router.push({
        path: '/collect/healthScoreTrend',
        query: { robotSn: row.robotSn }
      })
    },
    addConfigTable (type) {
      this.detailform.source = type
      this.dialogFormVisible = true
      this.detailform.configList = []
      this.detailform.robotSn = ''
      this.detailform.cabinetSn = ''
      this.detailform.file = ''
      this.detailform.configList1 = []
      this.detailform.name = ''
      this.detailform.id = null
      this.selectedRow = null
      this.robotSnList = []
      this.fileList = []
      this.detailform.robotSnList = []
      this.configList = [
      {
          name: this.$t('service.version.controller'),
          file: null,
          type: 'ini',
          fileName: 'usersettings.ini'
        },
        {
          name: this.$t('process.cloningrecord.ioName'),
          file: null,
          type: 'ini',
          fileName: 'aliasname.ini'
        }, 
        {
          name: this.$t('process.cloningrecord.extendedIO'),
          file: null,
          type: 'xml',
          fileName: 'extiosetup.xml'
        },
        {
          name: this.$t('process.cloningrecord.systemVariables'),
          file: null,
          type: 'var',
          fileName: 'jaka_user.var'
        }, 
        {
          name: this.$t('process.cloningrecord.safetyZone'),
          file: null,
          type: 'xml',
          fileName: 'safezone.xml'
        }
      ]
    },
    enableChange (val) {
      request("cloneConfigDisable", {
        isDisable: val.isDisable,
        id: val.id,
      })
        .then((data) => {
          this.getData();
        })
        .catch((error) => {
          this.getData();
          console.error(error);
        });
    },
    async editSubmit () {
      this.$refs.detailformRef && await this.$refs.detailformRef.validate()
      const data = new FormData()
      Object.keys(this.detailform).forEach((key) => {
        if(key !== 'configList'){
          this.detailform[key] && data.append(key, this.detailform[key])
        }
      })
      if(this.detailform.source == 1){
        request('createUploadTask', this.detailform)
        .then(data => {
          this.dialogFormVisible = false
          this.getData();
        })
        .catch(error => {
          console.error(error)
        })
      }else{
        if(this.selectedRow == null){
          ElMessage({
            showClose: true,
            type: "info",
            message: this.$t('process.configtable.selectAtLeastOneConfig')
          })
          return false
        }
        this.selectedRow.map(item=>{data.append('files', item?.file);})
        data.append("configList", this.selectedRow.map(item=>item.name).join(','))
        request('cloneConfigUpload', data)
          .then(data => {
            this.dialogFormVisible = false
            this.getData();
          })
          .catch(error => {
            console.error(error)
          })
        }
    },
    async handleOperate (row,type) {
      switch (type) {
        case 0: 
          this.detailform.id = row.id
          this.detailform.name = row.name
          this.detailform.robotSn = row.robotSn
          this.detailform.cabinetSn = row.cabinetSn
          this.detailform.file = row.file
          this.detailform.source = row.source
          this.detailform.configList = row.configList.split(',')
          this.dialogFormVisible = true
          this.robotSnQuery(row.robotSn)
          this.$nextTick(() => {
            this.detailform.configList.map(item=>{
              this.$refs.multipleTable.toggleRowSelection(this.configList.filter(it=> item == it.name)[0])
            })
          });
          this.configList = [{
          name: this.$t('service.version.controller'),
          file: null,
          type: 'ini',
          fileName: 'usersettings.ini'
        },
        {
          name: this.$t('process.cloningrecord.ioName'),
          file: null,
          type: 'ini',
          fileName: 'aliasname.ini'
        }, 
        {
          name: this.$t('process.cloningrecord.extendedIO'),
          file: null,
          type: 'xml',
          fileName: 'extiosetup.xml'
        },
        {
          name: this.$t('process.cloningrecord.systemVariables'),
          file: null,
          type: 'var',
          fileName: 'jaka_user.var'
        }, 
        {
          name: this.$t('process.cloningrecord.safetyZone'),
          file: null,
          type: 'xml',
          fileName: 'safezone.xml'
        }
      ]
          break;
        case 1:  
          this.$router.push({
            path: '/process/cloningRecord',
            query: { configId: row.id }
          });
         break;
        case 2:     
          this.$router.push({
            path: '/process/cloningRecord',
            query: { configCode: row.code, createTime: row.createTime }
          });
          break;
        case 3: 
          try {
            await ElMessageBox.confirm(
              this.$t('activity.list.confirmDelete'),
            {
              confirmButtonText: this.$t('activity.list.confirm1'),
              cancelButtonText: this.$t('activity.list.cancel'),
              type: 'warning',
            }
          )
          await reqCloneConfig(row.id)
          ElMessage({
            showClose: true,
            type: "success",
            message: this.$t('activity.packetreceive.deleteSuccess')
          })
          this.getData()
      } catch (error) {
        console.error(error)
      }
        break;
      }
  
    },
    onFileChange (file,it) {
        let res = false
        for (let item of ['ini', 'xml', 'var']) {
          if (file.name.includes(item)) {
            res = true
            break
          }
        }
        if (!res) {
          this.fileList = []
          ElMessage({
            showClose: true,
            type: "warning",
            message: this.$t('process.configtable.fileFormatRestriction')
          })
          return
        }
        it.row.file = file.raw
        it.row.raw = file.raw
        // this.configList[it.$index].raw = file.raw
    },
    onFileRemove (val,item) {
      item.file = undefined
      item.raw = undefined
    },
    async robotSnQuery (name) {
      try {
        this.robotSnList = []
        const res = await request('getCollectRobot', {
          robotId: name
        })
        this.robotSnList = (res.records || []).slice(0, 20)
      } catch (error) {
        console.error(error)
      }
    },
    onRobotChange (val) {
      const currtRobot = this.robotSnList.filter(item=> item.robotId == val)[0]
      this.detailform.cabinetSn = currtRobot.cabinetId
      this.detailform.robotStatus = currtRobot.status
    },
    handleSelectionChange(val) {
      this.selectedRow = val;
      console.log(this.selectedRow)
    },
    getSum(item){
      const sum = item.configList.split(',').reduce((sum, item) => {
        const foundItem = this.configTypeLists.find(type => type.value === item);
        return sum + (foundItem ? foundItem.fileSize : 0);
      }, 0).toFixed(2) + 'KB'
      console.log('cwww',sum)
      return sum
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.progress-text {
  font-size: 12px;
}
.desc_title{
  position: relative;
  padding-left: 12px;
  margin-bottom: 20px;
  font-size: 18px;
  color: #1677ff;
}
.desc_title::before{
  position: absolute;
  content: ' ';
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 16px;
  background-color: #1677ff;
}
:deep(.form .el-form-item) {
  margin-bottom: 0px !important;
}

:deep(.form .el-form-item.is-error) {
  margin-bottom: 22px !important;
}
</style>

